export default __webpack_public_path__ + "static/media/approved-big.46879a94.svg";